import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


import './assets/styles.css';

import 'chartist/dist/chartist.min.css'

router.afterEach((to) => {
  // Установка заголовка страницы
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  // Обновление мета-описания
  if (to.meta && to.meta.description) {
    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta');
      descriptionTag.name = "description";
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.setAttribute('content', to.meta.description);
  }
});

createApp(App).use(router).use(store).mount('#app');
